import { combineReducers } from "redux-immutable";

import { makeCrudStateReducer } from "seneca-common/utils/apiStates";
import { CrudConfig } from "seneca-common/utils/apiStates/common/const";

import tagsActionTypes, { ActionTypes } from "../action-types";
import { tagsCrudConfig } from "../consts";
import TagsFeature from "../models/TagsFeature";
import { makeReducer as makeCategoriesReducer } from "./state/categories";
import { makeReducer as makeTagsReducer } from "./state/tags";

export function makeReducer(
  actionTypes: ActionTypes,
  crudStateConfig: CrudConfig
) {
  const tagsFeatureReducer = combineReducers(
    {
      tags: makeTagsReducer(actionTypes),
      categories: makeCategoriesReducer(actionTypes),
      meta: makeCrudStateReducer(crudStateConfig)
    } as any,
    () => new TagsFeature() as any
  );

  return tagsFeatureReducer;
}

export default makeReducer(tagsActionTypes, tagsCrudConfig);
